import './ProjectCard.scss'

const ProjectCard = (props) => {
    const { imageSrc, projectDomain, projectName, dataOfCompletion, projectShortDescription } = {...props};
    console.log("Props:" + toString(props));
    return <div className="project-card mystic-evening" rel="preload">

        <div className='project-pic-div'>
            <a className='project-url' rel="preload" href={`project/${projectName}`}>
                <img className='project-pic' src={imageSrc} alt={projectName} />
                <div className='project-pic-overlay'></div>
            </a>
        </div>
        <div className='project-description'>
            <a className='project-url' rel="preload" href={`project/${projectName}`}>
                <p className='project-domain' >{dataOfCompletion}&nbsp;&nbsp; . &nbsp;&nbsp;<span>{projectDomain}</span></p>
                <h3 className='project-name'>{projectName}</h3>
                <p className='project-short-description muted'>{projectShortDescription}</p>
            </a>
        </div>
    </div>
}

export default ProjectCard;